export class Transferencias {
    token: string
    producto: number
    cuenta: number
    monto:number
    productosocio: number
    cuentasocio: number
    descripcion: string
}
